import React, { memo } from 'react';
import { X, Check } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Dependes totalmente del librito del mazo para entender algo', 'Memorizar significados te resulta frustrante y aburrido', 'No sabes cómo unir varias cartas en una lectura coherente', 'Dudas de todas tus interpretaciones y tienes miedo de equivocarte', 'Sientes que el Tarot es demasiado complicado para ti', 'Las cartas parecen hablar un idioma que no logras descifrar', 'Te sientes abrumado por el exceso de información contradictoria', 'Sientes que tienes intuición, pero no sabes cómo desarrollarla', 'Terminas consultando el manual en cada lectura, perdiendo fluidez'];
  const solutions = ['Comprendes el significado de cada carta sin memorizar', 'Interpretas combinaciones con total naturalidad', 'Sabes formular preguntas poderosas y efectivas', 'Realizas lecturas completas paso a paso con seguridad', 'Desarrollas una intuición sólida y confiable', 'Utilizas el Tarot como herramienta de autoconocimiento', 'Creas el hábito de practicar con total confianza', 'Ahorras horas de frustración buscando en Google', 'Ganas seguridad interpretando diferentes situaciones reales', 'Conectas con tu mazo de una forma profunda y personal'];
  return <section className="px-5 relative overflow-hidden" data-id="element-233">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-234">
        <div className="text-center mb-16" data-id="element-235">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-petroleum mb-8 leading-tight tracking-tight" data-id="element-236">
            ¿Te reconoces en esto?
          </h2>
          <p className="text-brand-terracotta text-lg font-semibold italic mb-12" data-id="element-237">
            De mirar las cartas con dudas… a interpretarlas con confianza.
          </p>

          <div className="space-y-4 text-left" data-id="element-238">
            {problems.map((problem, idx) => <div key={idx} className="bg-white pt-6 px-6 pb-4 rounded-3xl flex items-start gap-5 shadow-premium border border-brand-petroleum/5" data-id="element-239">
                <div className="bg-red-50 p-2 rounded-full flex-shrink-0" data-id="element-240">
                  <X className="text-red-400" size={18} data-id="element-241" />
                </div>
                <p className="text-sm text-brand-dark-grey font-medium leading-relaxed" data-id="element-242">
                  {problem}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center mb-20 max-w-lg mx-auto" data-id="element-243">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-petroleum mb-6 leading-tight" data-id="element-244">
            Y aprender Tarot puede ser mucho más sencillo de lo que imaginas…
          </h3>
          <p className="text-brand-medium-grey text-base leading-relaxed" data-id="element-245">
            No necesitas un don especial ni memorizar cientos de significados.
            Solo necesitas un sistema que te guíe paso a paso.
          </p>
        </div>

        <div className="bg-brand-soft-cream p-8 md:p-12 rounded-[40px] border border-brand-petroleum/5 relative overflow-hidden" data-id="element-246">
          <p className="text-brand-petroleum font-bold text-xl md:text-2xl mb-12 text-center tracking-tight" data-id="element-247">
            Esto es lo que logras con el{' '}
            <span className="text-brand-gold-warm" data-id="element-248">Método Tarot Listo™</span>:
          </p>
          <div className="space-y-6" data-id="element-249">
            {solutions.map((item, i) => <div key={i} className="flex items-center gap-5" data-id="element-250">
                <div className="bg-brand-gold-warm/10 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 border border-brand-gold-warm/20" data-id="element-251">
                  <Check className="text-brand-gold-warm" size={20} data-id="element-252" />
                </div>
                <p className="text-brand-dark-grey text-sm md:text-base font-semibold tracking-tight" data-id="element-253">
                  {item}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}